var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Mixins, Watch, Component, Prop } from 'vue-property-decorator';
import RouteService from '@/common/services/routeService';
import { Focusable } from '@/common/mixins/Focusable';
var NavRow = /** @class */ (function (_super) {
    __extends(NavRow, _super);
    function NavRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(NavRow.prototype, "routeService", {
        get: function () {
            return new RouteService(this.$router);
        },
        enumerable: false,
        configurable: true
    });
    NavRow.prototype.isActiveRoute = function (route) {
        if (this.$route.meta.title == route.meta.title) {
            return "step";
        }
        return "false";
    };
    NavRow.prototype.onRouteNameChange = function () {
        this.focusOnFirstTag('h1');
    };
    Object.defineProperty(NavRow.prototype, "activeIndex", {
        get: function () {
            var len = this.routes.length;
            for (var i = 0; i < len; i++) {
                if (this.$route.meta.title == this.routes[i].meta.title) {
                    return i;
                }
            }
            return -1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NavRow.prototype, "activeRoute", {
        get: function () {
            var len = this.routes.length;
            for (var i = 0; i < len; i++) {
                if (this.$route.meta.title == this.routes[i].meta.title) {
                    return this.routes[i];
                }
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NavRow.prototype, "previousRoute", {
        get: function () {
            var index = this.activeIndex;
            if (index == -1 || index == 0)
                return null;
            else
                return this.routes[index - 1];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NavRow.prototype, "nextRoute", {
        get: function () {
            var index = this.activeIndex;
            if (index == -1 || index == this.routes.length - 1)
                return null;
            else
                return this.routes[index + 1];
        },
        enumerable: false,
        configurable: true
    });
    NavRow.prototype.showValidationError = function (route) {
        if (!this.enableNotification)
            return false;
        var targetRoute = this.routes.find(function (r) { return r.name == route; });
        var sectionValidationErrors = this.validationErrors.filter(function (error) { return error.groupId == targetRoute.meta.section; });
        return sectionValidationErrors.length > 0;
    };
    __decorate([
        Prop(Array),
        __metadata("design:type", Array)
    ], NavRow.prototype, "validationErrors", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], NavRow.prototype, "enableNotification", void 0);
    __decorate([
        Prop(Array),
        __metadata("design:type", Array)
    ], NavRow.prototype, "routes", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], NavRow.prototype, "condensed", void 0);
    __decorate([
        Watch('$route.name'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], NavRow.prototype, "onRouteNameChange", null);
    NavRow = __decorate([
        Component({
            name: "NavRow"
        })
    ], NavRow);
    return NavRow;
}(Mixins(Focusable)));
export default NavRow;
